import * as HoverCard from "@radix-ui/react-hover-card";

import { classNames } from "@/react/helpers/twMergeWithCN";

import { ActivityCard, ScoreChip } from "../";
import type { ActivityScoreDetail } from "../utils";

export const HoverScoreChip = ({
  scoreDetail,
  className,
}: {
  scoreDetail: ActivityScoreDetail;
  className?: string;
}) => (
  <HoverCard.Root openDelay={500}>
    <HoverCard.Trigger asChild>
      <div className={classNames("cursor-pointer", className)}>
        <ScoreChip activityScore={scoreDetail.activityScore} />
      </div>
    </HoverCard.Trigger>
    <HoverCard.Portal>
      <HoverCard.Content className="z-[1060]" sideOffset={10} align="start">
        <ActivityCard scoreDetail={scoreDetail} />
      </HoverCard.Content>
    </HoverCard.Portal>
  </HoverCard.Root>
);
